import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    getCompliancePermissions,
    getCompliancePermissionsFailure,
    getCompliancePermissionsSuccess,
    loadCompliancePermissionFromFacilityTab,
    loadCompliancePermissionFromPartnerNetworkSubcontractorGrid,
    loadCompliancePermissionFromQmAssociationDetails,
    loadCompliancePermissionFromRecruitingCandidates,
    loadCompliancePermissionsFailure,
    loadCompliancePermissionsFromCLEdit,
    loadCompliancePermissionsFromPrestartGrid,
    loadCompliancePermissionsFromQMAssociation,
    loadCompliancePermissionsFromTeamInfo,
    loadCompliancePermissionsSuccessfully,
    loadCompliancePermissionsWorkingListGrid
} from 'src/app/compliance/store/actions/compliance.actions';
import { ComplianceReportClient } from '../../api/compliance-report-client.service';
import { CompliancePermissions } from '../../models/compliance.permissions';
import { loadCompliancePermissionsFromCSEdit } from '../actions/compliance.actions';
import { selectCompliancePermissions } from '../selectors/compliance.selectors';
import { ComplianceClient } from '../../api/compliance-client.service';

@Injectable()
export class CompliancePermissionsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _store: Store,
        private readonly complianceReportClient: ComplianceReportClient,
        private readonly complianceClient: ComplianceClient
    ) {}

    loadComplianceReportPermissions$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(
                loadCompliancePermissionsFromQMAssociation,
                loadCompliancePermissionsFromTeamInfo,
                loadCompliancePermissionsFromPrestartGrid,
                loadCompliancePermissionsWorkingListGrid,
                loadCompliancePermissionsFromCSEdit,
                loadCompliancePermissionFromFacilityTab,
                loadCompliancePermissionFromPartnerNetworkSubcontractorGrid,
                loadCompliancePermissionFromQmAssociationDetails,
                loadCompliancePermissionsFromCLEdit,
                loadCompliancePermissionFromRecruitingCandidates
            ),
            switchMap(() => {
                return this.complianceReportClient.permissions().pipe(
                    map((permissions) => loadCompliancePermissionsSuccessfully({ permissions })),
                    catchError((error: unknown) => of(loadCompliancePermissionsFailure({ error })))
                );
            })
        );
    });

    loadCompliancePermissions$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(getCompliancePermissions),
            concatLatestFrom(() => this._store.select(selectCompliancePermissions)),
            switchMap(([, storedPerms]) => {
                if (storedPerms) {
                    return of(getCompliancePermissionsSuccess({ compliancePermissions: storedPerms }));
                }

                return this.complianceClient.getCompliancePermissions().pipe(
                    map((permissions: CompliancePermissions) =>
                        getCompliancePermissionsSuccess({ compliancePermissions: permissions })
                    ),
                    catchError((error: unknown) => of(getCompliancePermissionsFailure({ error })))
                );
            })
        );
    });
}
